import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const IconWrapper = styled(Stack)(
  ({theme}) => css`
    position: relative;

    ${theme.respondUpTo(
      'lg',
      css`
        padding-right: 12px;
        padding-top: 20px;
      `
    )};
  `
);
